/**
 * Custom hook untuk mengambil semua data room maintenance
 * 
 * API Endpoint: GET `/api/room-maintenance`
 * API Version: 3.0
 * 
 * @returns {object} - Semua data room maintenance beserta metadata dari data tersebut
 * @example
 * const { data, isLoading, error } = useGetAllBooking();
 */

import { useQuery } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { IndexRoomMaintenanceResponse } from "../response/IndexRoomMaintenanceResponse";

const API_VERSION = "v4";

interface DateProp {
    gte: string;
    lte: string;
}

interface FilterProps {
    id?: string;
    status?: string;
    room_type_id?: string;
    room_id?: string;
    date?: DateProp;
    checkin_date?: DateProp;
    checkout_date?: DateProp;
}

interface IndexRoomMaintenanceProps {
    filters?: FilterProps,
    search?: string,
    page?: number,
    limit?: number,
    queryKey?: string,
    include?: string,
    all?: number
}

const useIndexRoomMaintenance = (query: IndexRoomMaintenanceProps) => {
    return useQuery({
        // queryKey: [
        //     'bookings',
        //     'booking',
        //     'room-maintenance',
        //     ...Object.entries(query.filters ?? {})
        //         .map(([key, value]) => `${key}:${value}`),
        //     query.search,
        //     query.page,
        //     query.limit,
        //     query.queryKey,
        // ],
        queryKey: [
            'bookings',
            'booking',
            'room-maintenance',
            query.search,
            query.page,
            query.limit,
            query.queryKey,
            query.include,
            query.all,
            JSON.stringify(query.filters ?? {})
        ],
        queryFn: async () => {
            try {
                const params = {
                    filter: Object.fromEntries(
                        Object.entries(query.filters ?? {}).filter(([_key, value]) => value !== undefined && value !== null && value !== "")
                    ),
                    search: query.search || "",
                    page: query.page ?? 1,
                    limit: query.limit ?? 10,
                    include: query.include,
                    ...(query?.all ? { all: 1 } : {}),
                }

                const response = await privateApi.get(`/${API_VERSION}/room-maintenance`, { params });

                // Validasi response
                const validationResult = IndexRoomMaintenanceResponse.safeParse(response.data);
                if (!validationResult.success) {
                    console.error("Validation failed:", validationResult.error.errors);
                    throw new Error("Invalid Room Maintenance data format");
                }
                return validationResult.data;
            } catch (error) {
                console.error(`Failed to fetch Room maintenance`, error);
                throw error;
            }
        },
        retry: import.meta.env.VITE_MAX_RETRY,
        refetchOnWindowFocus: false,
    });
};

export default useIndexRoomMaintenance;